export enum Permission {
  ReadOnly = 'revoke_writes.legacy_permission',
  ManageUsers = 'manage_users.legacy_permission',
  AdminPanel = 'admin_panel.legacy_permission',
  AdminAccountManagement = 'admin_account_management.legacy_permission',
  PartnerDocsManagement = 'partner_docs.manage_roles',
  ViewWarehouseSecurity = 'warehouse_security.view',
  ManageWarehouseSecurity = 'warehouse_security.modify',
}
